export default {"src":"/_next/static/media/lightning-bolt.c7639fd4.svg","height":32,"width":26};